import { defineMessages } from "react-intl";

export const messages = defineMessages({
  dailyBudgetLabel: {
    id: "ads_manager.campaign_budget.type.daily.label",
    defaultMessage: "Daily budget",
    description: "Label for a daily campaign budget.",
  },
  campaignBudgetLabel: {
    id: "ads_manager.campaign_budget.type.campaign.label",
    defaultMessage: "Campaign budget",
    description: "Label for a lifetime campaign budget.",
  },
  dailyBudgetDisplay: {
    id: "ads_manager.campaign_budget.type.daily.display",
    defaultMessage: "{formattedAmount}/day",
    description: "Display value for a daily campaign budget.",
  },
  dailyBudgetMinimumError: {
    id: "ads_manager.campaign_budget.validation.daily.minimum",
    defaultMessage: "Enter a daily budget of at least {minimumAmount}.",
    description: "Validation error when a daily campaign budget is too low.",
  },
  campaignBudgetMinimumError: {
    id: "ads_manager.campaign_budget.validation.campaign.minimum",
    defaultMessage: "Enter a budget of at least {minimumAmount}.",
    description: "Validation error when a lifetime campaign budget is too low.",
  },
  updateFailedError: {
    id: "ads_manager.campaign_budget.error.update_failed",
    defaultMessage: "Failed to update budget",
    description: "Error when an inline campaign-budget update request fails.",
  },
  updateSuccess: {
    id: "ads_manager.campaign_budget.toast.updated",
    defaultMessage: "Updated campaign budget.",
    description: "Toast shown after an inline campaign-budget update succeeds.",
  },
  updateError: {
    id: "ads_manager.campaign_budget.toast.update_error",
    defaultMessage: "Error updating campaign budget.",
    description: "Toast shown after an inline campaign-budget update fails.",
  },
  updateFailedRetryError: {
    id: "ads_manager.campaign_budget.error.update_failed_retry",
    defaultMessage: "Failed to update budget. Please try again.",
    description: "Fallback error when an inline campaign-budget update fails.",
  },
  validNumberError: {
    id: "ads_manager.campaign_budget.validation.valid_number",
    defaultMessage: "Enter a valid number.",
    description: "Validation error when an inline campaign-budget value is not numeric.",
  },
  dailyBudgetHint: {
    id: "ads_manager.campaign_budget.type.daily.hint",
    defaultMessage: "The amount you're willing to spend per day",
    description: "Hint for an inline daily campaign-budget input.",
  },
  campaignBudgetHint: {
    id: "ads_manager.campaign_budget.type.campaign.hint",
    defaultMessage: "The total amount you're willing to spend per campaign",
    description: "Hint for an inline lifetime campaign-budget input.",
  },
  cancelAction: {
    id: "ads_manager.campaign_budget.button.cancel",
    defaultMessage: "Cancel",
    description: "Button label for cancelling an inline campaign-budget edit.",
  },
  savingAction: {
    id: "ads_manager.campaign_budget.button.saving",
    defaultMessage: "Saving...",
    description: "Button label while saving an inline campaign-budget edit.",
  },
  saveAction: {
    id: "ads_manager.campaign_budget.button.save",
    defaultMessage: "Save",
    description: "Button label for saving an inline campaign-budget edit.",
  },
});
